// Custom Shopify Analytics & Event Tracking
  
//  Publish custom_data_ready event on window load
window.addEventListener("load", () => {
if (window.Shopify?.analytics?.publish) {
    window.Shopify.analytics.publish('custom_data_ready', window.digitalData);
    console.log('[Analytics] Published custom_data_ready:', window.digitalData);
} else {
    console.warn('[Analytics] Shopify.analytics.publish not available');
}
});
  
// Collection item click tracking
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.new-product-card').forEach(card => {
        card.addEventListener('click', () => {
        const {
            productId,
            productName,
            productBrand,
            productPrice,
            productSku,
            collectionTitle,
            collectionId
        } = card.dataset;

        const eventData = {
            productId,
            productName,
            productBrand,
            productPrice: parseFloat(productPrice),
            productSku,
            collection: {
            title: collectionTitle,
            id: collectionId
            }
        };

        //console.log('📦 Event data to publish:', eventData);
        window.Shopify?.analytics?.publish('collection_item_selected', eventData);
        });
    });
  
    // Collection view tracking via embedded script data
    document.querySelectorAll('[id^="collection-data-"]').forEach(scriptTag => {
        try {
        const collectionData = JSON.parse(scriptTag.textContent);
        window.Shopify?.analytics?.publish('custom_collection_viewed', collectionData);
        //console.log('custom_collection_viewed event published:', collectionData);
        } catch (e) {
        console.error('Failed to parse collection data for analytics:', e);
        }
    });
    
    // Klaviyo Form Event Tracking (using MutationObserver)
    const formConfigs = [
        {
        selector: '.klaviyo-form-REJiWC button',
        eventName: 'email_subscription',
        location: 'footer',
        logLabel: 'Email Footer'
        },
        {
        selector: '.klaviyo-form-UDwzdZ button',
        eventName: 'sms_subscription',
        location: 'footer',
        logLabel: 'SMS Footer'
        },
        {
        selector: '[data-testid=klaviyo-form-TXuCeG] button',
        eventName: 'sign_up_and_save',
        location: 'popup',
        logLabel: 'Popup'
        }
    ];

    const observer = new MutationObserver(() => {
        formConfigs.forEach(config => {
        const buttons = document.querySelectorAll(config.selector);
        if (buttons.length > 0) {
            const lastButton = buttons[buttons.length - 1];

            if (!lastButton.classList.contains('event-attached')) {
            lastButton.classList.add('event-attached');

                lastButton.addEventListener('click', (event) => {
                    window.Shopify?.analytics?.publish(config.eventName, {
                    subscription_location: config.location
                    });
                
                    console.log('Published:', config.eventName, config.location);
                });
            }
        }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
